module.exports = __webpack_public_path__ + "img/baloto.484e78f.svg";